import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import FunnelChart from './../FunnelChart';
import useManagementDashboard from './useManagementDashboard';

const StudentOnboarding = () => {
    const { state } = useContext(SmartContext);
    const { getStudentOnboarding } = useManagementDashboard();
    const criteria = state.data.searchCriteria.onboarding;
    const data = state.data?.reportData?.onboarding;

    useEffect(() => {
        getStudentOnboarding();
    }, [criteria]);

    if (isEmpty(state.data?.reportData?.onboarding)) return null;

    return (
        <>
            <FunnelChart keys={Object.keys(data)} values={Object.values(data)} />
        </>
    );
};

export default StudentOnboarding;
